import React, { Component } from 'react'
import '../styles/CustomCookieBanner.css'
import CookieBanner from 'react-cookie-banner'
import CookieIcon from '../images/icons/cookie-icon.png'
import { webURL } from '../webURL'

class CustomCookieBanner extends Component {
  render() {
    return (
      <CookieBanner
        onAccept={() => {}}
        cookie="user-has-accepted-cookies"
        dismissOnScroll={false}
        disableStyle={true}>
        <div className="cookie-banner">
          <div className="cookie-text">
            <img
              src={CookieIcon}
              alt="cookie"
              className="cookie-icon" />
            <p>Ce site utilise de délicieux cookies afin de vous offrir la meilleure experience possible. <a href={`${webURL}mentions-legales/`}>En savoir plus</a></p>
          </div>
          <div className="accept-cookies-button" onClick={this.props.acceptCookies}>
            <span className="accept-cookies-button-text">J'accepte les cookies</span>
            <span className="accept-cookies-button-text--mobile">OK</span>
          </div>
        </div>
      </CookieBanner>
    );
  }
}

export default CustomCookieBanner;



// WEBPACK FOOTER //
// ./src/components/CustomCookieBanner.js